export default {"src":"/_next/static/media/annulation.a3599282.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};